"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("./store");
exports.createStore = function (param1, param2, param3) {
    return (typeof param2 === 'function')
        ? new store_1.Store(param1, undefined, param2)
        : new store_1.Store(param1, param2, param3);
};
//# sourceMappingURL=create-store.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngfk/ts-redux/dist/create-store.js
// module id = 104
// module chunks = 0